import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  PosaljiPredracuneEmailomCommand,
  RacuniClient,
} from '@kodit/core/data-api';
import { AlertService, AuthService, SharedService } from '@kodit/core/services';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'kodit-posalji-predracune-emailom-form',
  templateUrl: './posalji-predracune-emailom-form.component.html',
  styleUrls: ['./posalji-predracune-emailom-form.component.scss'],
})
export class PosaljiPredracuneEmailomFormComponent implements OnInit, OnDestroy {
  /** Subscription */
  private _subs: Subscription = new Subscription();

  /** Props */
  racunIds: number[] = [];
  form: FormGroup;

  constructor(
    private _fb: FormBuilder,
    private _dialogRef: DynamicDialogRef,
    private _dialogConfig: DynamicDialogConfig,
    private _client: RacuniClient,
    private _authService: AuthService,
    private _sharedService: SharedService,
    private _alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.racunIds = this._dialogConfig.data.racunIds;

    this.form = this._fb.group({
      fromId: new FormControl(null, {
        validators: [Validators.required],
      }),
      mailNaslov: new FormControl(
        `Predračun od ${this._authService.getCurrentTenantName}`,
        {
          validators: [Validators.required, Validators.maxLength(65)],
        }
      ),
      customPoruka: new FormControl(null),
    });

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this._posalji();
      })
    );
  }

  private _posalji() {
    if (!this.form.valid) {
      this._alertService.addWarnMsg(
        'Izaberite pošiljaoca i unesite naslov (najviše 65 karaktera).'
      );
      return;
    }

    this._sharedService.displayLoadingScreen(true, 'Pokretanje slanja...');
    this._subs.add(
      this._client
        .posaljiPredracuneEmailom(
          new PosaljiPredracuneEmailomCommand({
            racunIds: this.racunIds,
            fromId: this.form.value.fromId,
            mailNaslov: this.form.value.mailNaslov,
            customPoruka: this.form.value.customPoruka || undefined,
          })
        )
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe((res) => {
          this._alertService.addSuccessMsg(res.data);
          this._dialogRef.close(true);
        })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
